export function TreeAttrs() {
  return {
    isDataModel: false,
    defaultExpandAll: true,
    expandOnClickNode: true,
    filter: false,
    showCheckbox: false,
    accordion: false,
    lazy: false,
    currentNodeKeyFirst: false,
    width: "200",
    nodeKey: "id",
    propsLabel: "label",
    propsChildren: "children",
    dataTransitionFn: "",
    filterFn: "",
    loadFn: "",
    nodeClick: "",
    dataTransitionParentField: "",
    dataTransitionCurField: "",
    renderContent: "",
    requestUrl: "",
    requestType: "",
    requestParamsConfig: {},
    treeSql: "",
    style: "",
    deliveryField: "",
    defaultCheckedKeys: "",
    defaultExpandedKeys: "",
    currentNodeKey: "",
    iconClass: ""
  };
}
